'use client';

import { Button, Message } from '@sprd/sprd-component-kit/v2';
import { useTranslations } from 'next-intl';
import { usePageChrome } from '@/hooks/usePageChrome';
import { useZendeskChat } from '@/components/ZendeskChat/ZendeskChatContext';

export const ZendeskChatButton = () => {
  const t = useTranslations('supportChat');
  const { hideChatButton } = usePageChrome();
  const { openChatDialog, unreadMessageCount, isChatOpen, isInitialized } = useZendeskChat();

  // Unmounts while the chat is open rather than fading out: it shares a flex
  // column with the back-to-top button, so a hidden-but-present button would
  // hold an empty slot open. The chat panel covers this corner anyway.
  if (hideChatButton || !isInitialized || isChatOpen) {
    return;
  }

  return (
    <Button
      className="shadow-md"
      isRound
      variant="primary"
      onClick={openChatDialog}
      aria-live="polite"
      aria-label={t('a11y.chat', { count: unreadMessageCount })}
    >
      <Message className="m-0.5 size-6 text-white" aria-hidden />
      {unreadMessageCount > 0 && (
        <span
          aria-hidden
          className="absolute -top-1 -right-1 flex h-5 min-w-5 items-center justify-center rounded-l-xl rounded-r-xl bg-brand-green-dark px-1 text-xs text-white"
        >
          {unreadMessageCount}
        </span>
      )}
    </Button>
  );
};
